export enum FieldMapItemType {
  audience_field = 'audience_field',
  static_value = 'static_value',
}
